import React, { createContext, useState, useContext, useEffect } from 'react';
import { MOCK_USERS } from '@/lib/mockData';

const AUTH_STORAGE_KEY = 'swap_talence_user_id';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoadingAuth, setIsLoadingAuth] = useState(true);
  const [isLoadingPublicSettings, setIsLoadingPublicSettings] = useState(false);
  const [authError, setAuthError] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const [appPublicSettings, setAppPublicSettings] = useState(null);

  useEffect(() => {
    checkAppState();
  }, []);

  const loadStoredUser = () => {
    const storedId = localStorage.getItem(AUTH_STORAGE_KEY);
    const demoUser = MOCK_USERS.find((u) => u.id === storedId) ?? MOCK_USERS[0];
    return { ...demoUser, role: demoUser.id === '1' ? 'admin' : 'user' };
  };

  const checkAppState = async () => {
    setIsLoadingPublicSettings(false);
    setAuthError(null);
    setAppPublicSettings({ id: 'swap-talence', public_settings: {} });
    await checkUserAuth();
  };

  const checkUserAuth = async () => {
    try {
      setIsLoadingAuth(true);
      const currentUser = loadStoredUser();
      setUser(currentUser);
      setIsAuthenticated(true);
    } catch (error) {
      console.error('User auth check failed:', error);
      setIsAuthenticated(false);
      setAuthError({
        type: 'unknown',
        message: error.message || 'Authentication failed',
      });
    } finally {
      setIsLoadingAuth(false);
      setAuthChecked(true);
    }
  };

  const logout = () => {
    localStorage.removeItem(AUTH_STORAGE_KEY);
    setUser(null);
    setIsAuthenticated(false);
    window.location.href = '/welcome';
  };

  const navigateToLogin = () => {
    const demoUser = MOCK_USERS[0];
    localStorage.setItem(AUTH_STORAGE_KEY, demoUser.id);
    window.location.href = '/discover';
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isAuthenticated,
        isLoadingAuth,
        isLoadingPublicSettings,
        authError,
        appPublicSettings,
        authChecked,
        logout,
        navigateToLogin,
        checkUserAuth,
        checkAppState,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
